import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import masterDocumentService from "services/Setup/Master/masterDocumentService";
import { message } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  masterDocumentList: {},
};

export const getMasterDocumentList = createAsyncThunk(
  "masterDocument/getMasterDocumentList",
  async (data, { rejectWithValue }) => {
    console.log(
      "🚀 ~ file: masterDocumentSlice.js:30 ~ getmasterDocumentList ~ data:",
      data
    );
    try {
      const response = await masterDocumentService.getMasterDocumentList();
      console.log(
        "🚀 ~ file: masterDocumentSlice.js:33 ~ getmasterDocumentList ~ response:",
        response
      );
      if (response) {
        console.log("get list executed");
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: masterDocumentSlice.js:32 ~ getmasterDocumentList ~ response:",
        error
      );
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const masterDocument = createSlice({
  name: "masterDocument",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //list
      .addCase(getMasterDocumentList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterDocumentList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterDocumentList = action.payload;
      })
      .addCase(getMasterDocumentList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  masterDocument.actions;

export default masterDocument.reducer;
